







import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import HsabExpenseReimbursementDenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseReimbursementDenialReason.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { HsabExpenseReimbursementDenialReason }
})
export default class HsabExpenseCardRowDenial extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense () {
    return this.hsabExpenseFormStore.expense;
  }
  get hasDenialReasons (): boolean {
    return this.hsabExpenseFormStore.hasExpense
        && this.expense.reimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
  }
}
